import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "paddingAdjustments", "rainbowBorder", "rainbowBorderAnimation", "disablePadding", "css"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import { useAIThemeColor } from '../../styles/theme';
import { defaultPaddingStyles, floatingContainerStyles, getPaddingAdjustments, prismBorderAnimationStyles, prismBorderStyles } from './styles';
export var FloatingContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    paddingAdjustments = _ref.paddingAdjustments,
    _ref$rainbowBorder = _ref.rainbowBorder,
    rainbowBorder = _ref$rainbowBorder === void 0 ? true : _ref$rainbowBorder,
    rainbowBorderAnimation = _ref.rainbowBorderAnimation,
    disablePadding = _ref.disablePadding,
    css = _ref.css,
    rest = _objectWithoutProperties(_ref, _excluded);
  var paddingStyles = disablePadding ? null : paddingAdjustments ? getPaddingAdjustments(paddingAdjustments) : defaultPaddingStyles;
  var aiThemeColor = useAIThemeColor();
  var cssStyles = [floatingContainerStyles, paddingStyles, css];
  if (rainbowBorder) {
    cssStyles.push(prismBorderStyles(aiThemeColor));
    if (rainbowBorderAnimation) {
      cssStyles.push(prismBorderAnimationStyles);
    }
  }
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("div", _extends({
      ref: ref,
      css: cssStyles
    }, rest), children)
  );
});